export default function DoodleBackground() {
  return (
    <svg className="doodle-bg" aria-hidden="true">
      <defs>
        <pattern
          id="jowey-doodles"
          width="260"
          height="260"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(-8)"
        >
          {/* heart */}
          <g transform="translate(24,30) scale(0.9)">
            <path d="M0,6 C0,2 3,0 6,0 C8,0 10,1 11,3 C12,1 14,0 16,0 C19,0 22,2 22,6 C22,11 16,15 11,20 C6,15 0,11 0,6 Z" />
          </g>

          {/* small heart, opposite corner */}
          <g transform="translate(222,44) scale(0.55) rotate(18)">
            <path d="M0,6 C0,2 3,0 6,0 C8,0 10,1 11,3 C12,1 14,0 16,0 C19,0 22,2 22,6 C22,11 16,15 11,20 C6,15 0,11 0,6 Z" />
          </g>

          {/* yarn spiral */}
          <g transform="translate(150,55) rotate(12)">
            <path d="M0,9 a9,9 0 1,1 18,0 a5.5,5.5 0 1,1 -11,0 a2.5,2.5 0 1,1 5,0" />
          </g>

          {/* sparkle */}
          <g transform="translate(212,140) rotate(-15)">
            <path
              className="doodle-fill"
              d="M0,-9 L1.8,-1.8 L9,0 L1.8,1.8 L0,9 L-1.8,1.8 L-9,0 L-1.8,-1.8 Z"
            />
          </g>

          {/* wavy thread */}
          <g transform="translate(16,150)">
            <path d="M0,10 Q10,0 20,10 T40,10 T60,10" />
          </g>

          {/* crochet stitches */}
          <g transform="translate(108,214) rotate(4)">
            <path d="M0,10 L5,0 L10,10 M16,10 L21,0 L26,10 M32,10 L37,0 L42,10" />
          </g>

          <circle className="doodle-fill" cx="188" cy="212" r="2.5" />
          <circle className="doodle-fill" cx="66" cy="58" r="2" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#jowey-doodles)" />
    </svg>
  );
}
